import { toRem } from "shared/helpers";
import styled from "styled-components";

export const DictionaryWrapper = styled.div`
    padding-top: 16px;
    padding-bottom: 16px;
`

export const LetterContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 12px;
    margin-bottom: 12px;
    
    &:not(:last-of-type) {
        border-bottom: 1px solid var(--border-muted, rgba(88, 93, 105, 0.15));
    }
`


export const LetterTitle = styled.div`
    color: var(--dropdownmenu-primary-title-color, rgba(16, 24, 40, 0.55));
    font-size: 12px;
    font-weight: 400;
    padding: 8px 12px;
`

export const DictionaryEntre = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    border-radius: var(--dropdownmenu-m-item-border-radius, 8px);
    
    transition: backgroung .3s ease-in-out;
    padding: 8px 12px;
    gap: 0;
    
    .edit-button {
        
        
        padding: 4px;
        position: absolute;
        right: 12px;
        top: 8px;
        width: var(--iconbutton-s-height, 24px);
        height: var(--iconbutton-s-height, 24px);

        display: none;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        
        border-radius: var(--iconbutton-s-border-radius, 8px);
        background: var(--iconbutton-ghost-neutral-bg-color-hover, rgba(88, 93, 105, 0.1));
    
        @media screen and (max-width: 1000px) {
            display: flex;
        }
   
    }

    &:hover {
        background: var(--neutral-container-muted, rgba(88, 93, 105, 0.03));
        
        .edit-button {
            display: flex;
        }
    }
`

export const DictionaryEntreTitle = styled.h4`
    color: var(--dropdownmenu-primary-itemvalue-color-default, rgba(16, 24, 40, 1));
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
`

export const DictionaryEntreDesc = styled.p`
    color: var(--dropdownmenu-primary-hint-color-default, rgba(16, 24, 40, 0.55));
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
`

export const VetisContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(8)};
  padding: ${toRem(16)} 0;
`;